import styled from '@emotion/styled';

export const TestPanelContainer = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  padding: 16px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h3`
  font-weight: bold;
  margin: 0;
  font-size: 16px;
`;

export const ToggleButton = styled.button`
  color: #718096;
  padding: 4px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  margin-left: auto;
  &:hover {
    background: #f7fafc;
    color: #4a5568;
  }
`;

export const AmountText = styled.div`
  font-size: 14px;
  color: #718096;
  margin-bottom: 8px;
`;

export const ApproveButton = styled.button`
  background: #48bb78;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  width: 100%;
  &:hover {
    background: #38a169;
  }
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
